import { defineStore } from 'pinia';
import { api } from '@/services/http.service';
import { SegmentListItem, SegmentListPayload } from '@/models/dictionary/segment-list.model';
import { showErrorNotification } from '@/utils/show-notification.util';

interface SegmentListState {
  segmentList: SegmentListItem[];
  isSegmentListLoading: boolean;
}

export const useSegmentListStore = defineStore('SegmentListStore',
  {
    state: (): SegmentListState => ({
      segmentList: [],
      isSegmentListLoading: false,
    }),
    getters: {
      isSegmentListNotEmpty(state: SegmentListState): boolean {
        return state.segmentList.length > 0;
      },
    },
    actions: {
      setSegmentListLoading(isLoading: boolean): void {
        this.isSegmentListLoading = isLoading;
      },
      setSegmentList(segmentList: SegmentListItem[]): void {
        this.segmentList = segmentList;
      },
      getSegmentList({ filterList, isForceUpdate = false }: SegmentListPayload): Promise<SegmentListItem[]> {
        if (this.segmentList.length && !isForceUpdate) {
          return Promise.resolve(this.segmentList);
        }

        this.setSegmentListLoading(true);

        return api.dictionary.getSegmentListRequest.perform({ filterList })
          .then((segmentListResponse: SegmentListItem[]) => {
            this.segmentList = segmentListResponse;

            return segmentListResponse;
          })
          .catch((error) => {
            showErrorNotification(error);

            return [];
          })
          .finally(() => {
            this.setSegmentListLoading(false);
          });
      },
    },
  });
